const getOrFallbackInObj = (map, key, defaultKey) => {
  const value = map[key];
  if (value === undefined) {
    return map[defaultKey];
  }
  return value;
};

export default getOrFallbackInObj;
